import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const CommonDialog = ({
  title,
  maxWidth = "lg",
  scroll = "paper",
  onClose,
  children,
  renderActions,
}) => {
  return (
    <Dialog open maxWidth={maxWidth} fullWidth scroll={scroll}>
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {typeof title === "string" ? (
            <Typography variant="h5">{title}</Typography>
          ) : (
            title
          )}
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {renderActions && <DialogActions>{renderActions()}</DialogActions>}
    </Dialog>
  );
};

export default CommonDialog;
